import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@navigation";

export function WebsiteGraphics() {
  const navigate = useNavigate();

  const folders = [
    { type: "locations", title: "Location Images", icon: "pi pi-map-marker" },
  ];

  const breadcrumbItems = [{ label: "Website Graphics" }];

  return (
    <div className="p-4">
      <BreadCrumb
        model={breadcrumbItems}
        home={{
          icon: "pi pi-home",
          command: () => navigate(`${ROUTES.ADMIN}/${ROUTES.DASHBOARD}`),
        }}
        className="mb-5"
      />

      <div className="grid">
        {folders.map((folder, i) => (
          <div key={i} className="col-12 sm:col-6 lg:col-4">
            <Card
              className="cursor-pointer transition-duration-300 hover:shadow-4 flex flex-column align-items-center justify-content-center"
              onClick={() =>
                navigate(
                  `${ROUTES.ADMIN}/${ROUTES.WEBSITE_SETTINGS}/${ROUTES.WEBSITE_GRAPHICS}/${folder.type}`,
                )
              }
            >
              <div
                className="flex flex-column align-items-center justify-content-center"
                style={{ height: "180px" }}
              >
                <i
                  className={`${folder.icon} text-6xl text-yellow-500 mb-3`}
                  style={{ filter: "drop-shadow(1px 1px 2px rgba(0,0,0,0.3))" }}
                />
                <span className="font-bold text-lg text-center">
                  {folder.title}
                </span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}
